module.exports = "<select name=\"{{name}}\" class=\"js-select | {{selectClass}}\"></select>\n<content></content>";
